<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Standard Admission Quota</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <v-autocomplete dense rounded v-model="ay" item-value="id" :items="ay_list[0]" item-text="ay"
                            label="Academic Year" outlined></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-autocomplete dense rounded v-model="standard" item-value="id" :items="standard_list"
                            item-text="standard" label="Standard" outlined></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" v-if="standard">
                        <v-text-field type="number" rounded outlined :rules="[(v) => !!v || 'required']"
                            v-model="no_of_forms" label="Number Of Forms Allowed" dense persistent-hint></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" v-if="standard">
                        <v-text-field type="number" rounded outlined :rules="[(v) => !!v || 'required']" v-model="fees"
                            label="Fees" dense persistent-hint></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" sm="3" v-if="ay && standard">
                 <v-btn  @click="show_card =true" dense :loading="loader" color="primary">Proceed</v-btn>
            </v-col> -->
                </v-row>
                <v-row>
                    <v-col cols="12" sm="3" v-if="standard">
                        <v-text-field type="number" rounded outlined :rules="[(v) => !!v || 'required']"
                            v-model="form_sequence" label="Form Sequence" dense persistent-hint></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" v-if="standard">
                        <v-textarea rounded outlined v-model="admission_schedule" label="Admission Schedule" dense
                            persistent-hint auto-grow></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="3" v-if="standard">
                        <v-textarea rounded outlined v-model="document_instructions" label="Document Instructions" dense
                            persistent-hint auto-grow></v-textarea>
                    </v-col>
                </v-row>
                <v-row justify="center" dense v-if="ay && standard">
                    <v-btn dense :loading="loader" color="primary" @click="save()">Save</v-btn>
                </v-row>
            </v-card>
            <v-dialog v-model="dialog">

                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        Update
                    </v-card-title>

                    <v-card-text>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="3">
                                <v-text-field type="number" rounded outlined v-model="edit_form_sequence"
                                    label="Form Sequence" dense persistent-hint></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-textarea rounded outlined v-model="edit_admission_schedule"
                                    label="Admission Schedule" dense persistent-hint auto-grow></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-textarea rounded outlined v-model="edit_document_instructions"
                                    label="Document Instructions" dense persistent-hint auto-grow></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer> </v-spacer>
                        <v-btn color="primary" text @click="cancelDialog()" outlined>
                            Cancel
                        </v-btn>
                        <v-btn color="primary" @click="update()">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


                <!-- new Academic year selector -->
            <v-card class="box" elevation="2">
            <v-row justify="center">
                <v-col cols="12" sm="3" class="pa-0 ma-0 mt-6">
                <v-autocomplete dense rounded v-model="unique_ay" :items="unique_ay_list" item-value="id" item-text="ay"
                    label="Fetch Data For Academic Year" outlined @change="showDetails"
                ></v-autocomplete>
                </v-col>
            </v-row>
            </v-card>


            <v-card class="box" v-if="standard_quota_list != ''">
                <v-data-table :headers="headers" :items="standard_quota_list" dense>
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>List</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>

                    <template v-slot:[`item.fee`]="{ item }">
                        <v-row dense>
                            <v-col cols="12" md="5" sm="5">
                                <v-text-field type="number" dense class="pt-3" persistent-hint label="Enter Fees"
                                    outlined rounded v-model="item.fee"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" sm="3">
                                <v-btn rounded class="button mt-5" dense small :loading="loader"
                                    @click="updateFees(item)">Update</v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:[`item.count`]="{ item }">
                        <v-row dense>
                            <v-col cols="12" md="5" sm="5">
                                <v-text-field type="number" dense class="pt-3" persistent-hint
                                    label="Enter Number Of Forms Allowed" outlined rounded
                                    v-model="item.count"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" sm="3">
                                <v-btn rounded class="button mt-5" dense small :loading="loader"
                                    @click="updateCount(item)">Update</v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:[`item.edit`]="{ item }">
                        <v-row dense>

                            <v-col cols="12" md="3" sm="3">
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-2 edit-v-icon" @click="editdialogopen(item)">mdi-pencil</v-icon>
                                </v-avatar>

                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
    </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        fees: 0,
        no_of_forms: 0,
        form_sequence: 1,
        loader: false,
        show_card: false,
        dialog: false,
        snackbar_msg: "",
        id: "",
        admission_schedule: "",
        document_instructions: "",
        edit_form_sequence: "",
        edit_admission_schedule: "",
        edit_document_instructions: "",
        color: "",
        snackbar: false,
        overlay: false,
        ay_list: [], ay: "", unique_ay:"",
        standard_list: [], standard: "", standard_quota_list: [],
        unique_ay_list:[],
        headers: [
            { text: "Sr No", value: "srno" },
            { text: "Standard", value: "standard" },
            { text: "Academic Year", value: "academicyear" },
            { text: "Fees", value: "fee" },
            { text: "No Of Forms Allowed", value: "count" },
            { text: "Edit", value: "edit" },
            // { text: "Form Sequence", value: "form_sequence" },
            // { text: "Admission Schedule", value: "admission_schedule" },
            // { text: "Document Instructions", value: "document_instructions" },
            { text: "Balance", value: "balance" },
        ],
    }),
    methods: {
        cancelDialog() {
            this.dialog = false;
        },
        editdialogopen(item) {
            this.id = item.id,
            this.edit_form_sequence = item.form_sequence;
            this.edit_admission_schedule = item.admission_schedule;
            this.edit_document_instructions = item.document_instructions;
            this.dialog = true;
        },
        async updateFees(item) {
            this.loader = true
            const data = {
                id: item.id,
                fees: item.fee,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/Admission/updateStandardFees", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Updated Successfully..");
                    this.standard_quota_list = res.data.standard_quota_list

                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
                this.loader = false
            }
        },
        async updateCount(item) {
            this.loader = true
            const data = {
                id: item.id,
                count: item.count,
            };
            this.overlay = true;
            try {
                const res = await axios.post("/Admission/updateStandardCount", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Updated Successfully..");
                    this.standard_quota_list = res.data.standard_quota_list
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
            } finally {
                this.overlay = false;
                this.loader = false
            }
        },
        async update() {
            this.loader = true
            const data = {
                id: this.id,
                form_sequence: this.edit_form_sequence,
                admission_schedule: this.edit_admission_schedule,
                document_instructions: this.edit_document_instructions,

            };
            this.overlay = true;
            try {
                const res = await axios.post("/Admission/updateStandardAdmissionQuotaDetails", data);
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Updated Successfully..");
                    this.standard_quota_list = res.data.standard_quota_list
                    this.dialog = false;

                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                    this.dialog = false;
                }
                this.overlay = false;
            } catch (err) {
                console.log("err", err);
                this.onerror(err);
                this.overlay = false;
                this.dialog = false;
            } finally {
                this.overlay = false;
                this.loader = false
                this.dialog = false;
            }
        },
        async save() {
            if (this.no_of_forms < 0) {
                this.showSnackbar("#b71c1c", "Cannot Be Negative..."); // show snackbar
            }
            if (this.fees < 0) {
                this.showSnackbar("#b71c1c", "Cannot Be Negative..."); // show snackbar
            }
            if (this.form_sequence < 0) {
                this.showSnackbar("#b71c1c", "Cannot Be Negative..."); // show snackbar
            }
            const data = {
                ay: this.ay,
                standard: this.standard,
                no_of_forms: this.no_of_forms,
                fees: this.fees,
                form_sequence: this.form_sequence,
                admission_schedule: this.admission_schedule,
                document_instructions: this.document_instructions,
            };
            try {
                const res = await axios.post("/Admission/saveStandardAdmissionQuota", data);         
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Saved Successfully..."); // show snackbar
                    this.standard_quota_list = res.data.standard_quota_list
                }
                else if (res.data.flag == "No") {
                    this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                }
                else {
                    this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                }
            }
            catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            } finally {
                this.save_loader = false;
            }

        },
        init_call() {
            axios
                .post("/Admission/standardAdmissionQuota")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay = res.data.ay_list[0].id
                        this.ay_list = res.data.ay_list
                        this.standard_list = res.data.standard_list
                        this.standard_quota_list = res.data.standard_quota_list
                        this.unique_ay_list = res.data.unique_ay_list
                        this.loader = true;
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

       // to get details only for selected ay
        showDetails(){
            const data = {
                ay: this.unique_ay 
            };
            this.loader = true;

            axios
                .post("/Admission/standardAdmissionQuotaByAy", data)
                .then((res) => {
                    if (res.data.flag == "YES") {                        
                        this.standard_quota_list = res.data.standard_quota_list;  
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                });       

        },

    },
    mounted() {
       this.init_call();
    },
    watch: {},
};
</script>

<style scoped>

/* Using the custom class to scope the fieldset override */
.white-autocomplete.v-text-field--outlined fieldset {
  border-color: white !important;
}
</style>

